export enum RoleChangeType {
    upgrade = 'upgrade',
    downgrade = 'downgrade',
    transfer = 'transfer',
}
